import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import TopBar from "components/Layout/TopBar";
import { logError } from 'components/Utils/FormatData';
import React, { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router";
import { ClipLoader } from 'react-spinners';
import MyButton from "../../components/Layout/MyButton";
import MyForm from '../../components/Layout/MyForm';
import { URL_API } from '../../utils/globalConfig';
import useAuthz from "../../hooks/useAuthz";

const CreateOrEditGrilleTarifaire = (props) => {
  const navigate = useNavigate();
  const alert = useAlert();
  const [authz, user, profil] = useAuthz();
  const [isLoading, setIsLoading] = useState(true);
  const routeUtilisateurs = "/panneau-administration/grille-tarifaire";
  const tarif_id = new URLSearchParams(location.search).get("id")
  const [tarifDetail, setTarifDetail] = useState({
    tarif_id: null,
    centre_id: [],
    libelle: null,
    unite: null,
    date_effet: null,
    date_fin_validite: null,
    tarif: null,
    code_comptable: null,
    description: null,
    mesures_exploit: null,
    deleted: false,
  });
  const [listCenters, setListCenters] = useState([]);
  const [form, setForm] = useState([
    {
      id: 'centre_id',
      name: 'centre_id',
      label: 'CENTRE',
      type: 'select',
      options: listCenters,
      value: tarifDetail.centre_id,
      disabled: false,
      displayLabel: true,
      labelClass: 'select-label-black',
      multiple: false,
      disableClass: true,
      formControlStyle: { width: '100%'},
      required: true,
    },
    {
      id: 'libelle', name: 'libelle', label: 'LIBELLE', type: 'text', required: true, readOnly: false, style: { width: '100%', margin: '20px' },
    },
    {
      id: 'unite', name: 'unite', label: 'UNITE', type: 'text', required: true, readOnly: false, style: { width: '100%', margin: '20px' },
    },
    {
      id: 'tarif',
      name: 'tarif',
      label: 'TARIF',
      type: 'text',
      required: true,
      readOnly: false,
      style: { width: '100%', margin: '20px' },
    },
    {
      id: 'code_comptable',
      name: 'code_comptable',
      label: 'CODE COMPTABLE *',
      type: 'text',
      required: false,
      readOnly: false,
      style: { width: '100%', margin: '20px' },
    },
    {
      id: 'description', name: 'description', label: 'DESCRIPTION *', type: 'text', required: false, readOnly: false, style: { width: '100%', margin: '20px' },
    },
    {
      id: 'mesures_exploit', name: 'mesures_exploit', label: 'MESURES EXPLOITATION', type: 'text', required: false, readOnly: false, style: { width: '100%', margin: '20px' },
    },
    {
      id: 'date_effet', name: 'date_effet', label: 'DATE EFFET', type: 'date', required: false, readOnly: false, style: { width: '100%', margin: '20px' }, hideError: true
    },
    {
      id: 'date_fin_validite', name: 'date_fin_validite', label: 'FIN VALIDITÉ', type: 'date', required: false, readOnly: false, style: { width: '100%', margin: '20px' }, hideError: true
    }
  ]);

  //#region useEffect

  useEffect(() => {
    if (profil.profil === 1) {
      if (tarif_id) {
        document.title = "TE - Editer une grille de tarif";
        fetchLoadTarif();
      } else {
        document.title = "TE - Créer une grille de tarif";
      }

      apiGetListCenters();
      setIsLoading(false);
    } else {
      alert.error("Vous n'êtes pas autorisé à accéder à ce module");
      navigate(routeUtilisateurs);
    }
  }, []);

  useEffect(() => {
    if (listCenters.length > 0) {
      let formData = [...form];

      formData.map((formDatum) => {
        if (formDatum.id === "centre_id") {
          formDatum.options = listCenters
        }
      });

      setForm(formData);
    }
  }, [listCenters]);

  //#endregion

  //#region Fonctions

  const handleChangeValue = (event, name) => {
    setTarifDetail({ ...tarifDetail, [event?.target?.name != null ? event?.target?.name : name]: event?.target?.value != null ? event?.target?.value : event });
    let formData = [...form];
    formData.map((formDatum) => {
      if (formDatum.id === event?.target?.name) {
        formDatum.value = event?.target?.value;
      }
    });

    if (event?.target?.name === "centre_id") {
      setTarifDetail({ ...tarifDetail, centre_id: event?.target?.value });
    }

    setForm(formData);
  };

  const handleCancel = () => {
    navigate(routeUtilisateurs);
  };

  const handleValid = () => {
    if (tarifDetail.libelle != null && tarifDetail.unite != null && tarifDetail.date_effet != null && tarifDetail.tarif != null && tarifDetail.code_comptable != null
      && tarifDetail.description != null && tarifDetail.deleted != null) {
      createOrEditTarif();
    } else {
      alert.error("Vous devez remplir l'ensemble des champs obligatoires avant de continuer");
    }
  };

  //#endregion

  //#region API

  const fetchLoadTarif = () => {
    axios({ method: 'get', url: `${URL_API}/grille-tarifaire/findById?tarifId=${tarif_id}` })
      .then((response) => {
        setTarifDetail(response.data);
        let formData = [...form];
        formData.map((formDatum) => {
          if (formDatum.id === "centre_id") {
            formDatum.value = response.data.centre_id;
          }
        });
        setForm(formData);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        logError(alert, error);
      });
  };

  const createOrEditTarif = () => {
    axios({ method: 'post', url: `${URL_API}/grille-tarifaire/create-or-edit`, data: tarifDetail, params: { userAction: user.user_id } })
      .then(() => {
        alert.success(tarifDetail.tarif_id !== null ? "L'édition de la grille de tarif a bien été effectuée" : "La création de la grille de tarif a bien été effectuée");
        navigate(routeUtilisateurs);
      })
      .catch((error) => {
        logError(alert, error);
      });
  };

  const apiGetListCenters = () => {
    axios({ method: 'get', url: `${URL_API}/localisation/list-all-centers`})
      .then(function(response) {
        setListCenters(response.data);
        setIsLoading(false);
      })
      .catch(function(err) {
        logError(alert, err);
      });
  };

  //#endregion

  return (
    <div style={{ height: '100%' }}>
      <TopBar title={tarif_id ? 'Editer une grille de tarif' : 'Créer une grille de tarif'} className='topbar-contenu' color={props.params.color} buttons={null} />

      <div className='row' style={{ alignItems: isLoading ? 'center' : '', height: 'calc(100% - 50px)', overflow: 'auto' }}>
        <ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'} />

        {!isLoading &&
          (
            <div className='form-content-center' style={{ minWidth: 750 }}>
              <MyForm
                data={tarifDetail}
                variant={'outlined'}
                setData={setTarifDetail}
                form={form}
                onChange={handleChangeValue}
              />
              <div className='row' style={{ width: '100%', margin: '20px' }}>
                <MyButton
                  onClick={handleCancel}
                  style={'buttonDefault'}
                  label={'Annuler'}
                  icon={faXmark}
                />
                <MyButton
                  onClick={handleValid}
                  style={'buttonValidation'}
                  label={'Valider'}
                  icon={faCheck}
                />
              </div>
            </div>
          )
        }
      </div>
    </div>
  );

}

export default CreateOrEditGrilleTarifaire;
